module.exports = __webpack_public_path__ + "img/collection-memoireRingsBudgetLow@2x.5871136.jpg";